import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Button, Form, Drawer, Checkbox } from 'antd'
import { intl, recordCountlyEvent } from 'utils'
import { Captcha, OTP, PhoneInput, WhiteSpace } from 'components'
import { Flex } from 'antd-mobile'
import { login, queryProtocol, removeCaptcha, loginToSaveCard } from 'store/siteConfig'
import { init } from 'routes/PayPage/Main/modules'
import WingBlank from 'components/WingBlank'
import { NavigatorWithQS } from 'utils/navigateWithQS'
import { DrawerHeader } from 'components/MobilePaymentContainer/DrawerHeader'
import { agreementRule } from 'utils/validateRules'
import { updateAliFingerprint } from 'utils/initAliFingerprint'

const MobileContentWrapper = (props) => (
  <Flex.Item>
    <div className={classes.componentsLoginDrawer}>{props.children}</div>
  </Flex.Item>
)
const MobileFooterWrapper = (props) => <div className={classes.formFooterContainer}>{props.children}</div>

const DrawerWrapper = ({ siteConfig, onChange, visible, children, title, drawerProps }) => (
  <Drawer
    title={
      siteConfig.isMobile ? null : (
        <div className={classes.header}>
          <div className={classes.bg}>
            {/* <img height={160} src={require('./images/botim-bg.svg')} /> */}
          </div>
          <img onClick={() => onChange(false)} className='close-icon' src={require('./images/close-icon.svg')} height={24} />
          {/* <WhiteSpace size='xxl' /> */}
          {/* <WhiteSpace size='xxl' /> */}
          <WhiteSpace size='xxl' />
          <div>{title}</div>
          <WhiteSpace size='xl' />
        </div>
      )
    }
    zIndex={100}
    closable={false}
    style={{ transform:undefined }}
    onClose={() => onChange(false)}
    visible={visible}
    {...drawerProps}
  >
    {children}
  </Drawer>
)

class LoginDrawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.props.queryProtocol({ protocolScene: 'PAYPAGE_LOGIN' })
    const { history, location } = props
    this.navigateWithQS = NavigatorWithQS.getInstance(history, location)
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { type, visible } = this.props
    visible &&
      recordCountlyEvent({
        page_name: type === 'LOGIN' ? 'paypage_home' : 'paypage_pay_result',
        event_name: 'popup',
        element_name: type === 'LOGIN' ? 'login_popup' : 'save_card_popup',
      })
  }

  handleSubmit = () => {
    const { form, type, login, loginToSaveCard, init, siteConfig } = this.props
    form.validateFields(async (errs, values) => {
      if (!errs) {
        recordCountlyEvent({
          page_name: type === 'LOGIN' ? 'paypage_home' : 'paypage_pay_result',
          event_name: 'click',
          element_name: type === 'LOGIN' ? 'check_create' : 'save',
        })
        const { memberPhone, country, ...resetValues } = values
        resetValues.memberPhone = `${country}-${memberPhone}`
        await updateAliFingerprint()
        switch (type) {
          case 'LOGIN':
            login({ otp: values.otp, memberPhone:resetValues.memberPhone }, form).then((res) => {
              res && init()
              // 处理手机端登录跳回卡选择页面
              res &&
                siteConfig.isMobile &&
                this.navigateWithQS.replace('/pay-page/main/mobile-payment-container/card-pay')
            })
            break
          case 'LOGIN_TO_SAVE_CARD':
            loginToSaveCard({ otp: values.otp, memberPhone:resetValues.memberPhone })
            break
          default:
            break
        }
      }
    })
  }

  render() {
    const { siteConfig, form, visible, onChange, pcProps, type, forceAsDrawer } = this.props

    var drawerProps
    if (!siteConfig.isMobile) {
      drawerProps = {
        className: classes.componentsLoginDrawer,
        style: {
          position: 'absolute',
        },
        width: '100%',
        placement: 'right',
        ...pcProps,
      }
    } else {
      drawerProps = {
        className: classes.componentsLoginDrawerMobile,
        placement: 'bottom',
        height:'90vh'
      }
    }

    const drawerFooterNode = (
      <>
        <Form.Item className={`${classes.checkbox} text-left`}>
          {form.getFieldDecorator('agreements', agreementRule())(
            <Checkbox>
              <span
                className='font-12'
                dangerouslySetInnerHTML={{
                  __html: siteConfig.agreementTips,
                }}
              />
            </Checkbox>
          )}
        </Form.Item>
        <WhiteSpace />
        <Button
          loading={siteConfig.LoginLoading}
          block
          type='primary'
          size='large'
          onClick={this.handleSubmit}
        >
          <span>{this.props.btnText}</span>
        </Button>
        {!siteConfig.isMobile && <WhiteSpace />}
      </>
    )

    const drawerContentNode = (
      <>
        <WhiteSpace />
        <Flex direction='column' align='center' justify='center'>
          <img height={112} src={require('./images/bg.svg')} />
          <span className='heading_1'>{intl().formatMessage(messages.yourPhoneNumber)}</span>
          <span className='paragraph_regular text-center'>{intl().formatMessage(messages.reason)}</span>
        </Flex>
        <WhiteSpace size='xl' />
        <Flex direction='column' align='stretch' className={classes.container}>
          <Flex.Item>
            <Form>
              <PhoneInput
                form={form}
                siteConfig={siteConfig}
                resetError={() => {
                  setTimeout(() => {
                    form.validateFields(['memberPhone'], (err, values) => {
                      this.setState({
                        available: !err,
                      })
                    })
                  }, 100)
                }}
                removeCaptcha={this.props.removeCaptcha}
              />
              <Captcha form={form} />
              {/* eslint-disable-next-line react/jsx-pascal-case */}
              <OTP
                form={form}
                available={this.state.available}
                eventType='PAYPAGE_LOGIN'
                required={['memberPhone', 'country', 'captcha']}
                type={type}
              />

              {!siteConfig.isMobile && drawerFooterNode}
            </Form>
          </Flex.Item>
        </Flex>
      </>
    )
    if (siteConfig.isMobile && forceAsDrawer !== true) {
      return (
        <>
          <MobileContentWrapper>{drawerContentNode}</MobileContentWrapper>
          <WingBlank>
            <MobileFooterWrapper>{drawerFooterNode}</MobileFooterWrapper>
            <WhiteSpace />
          </WingBlank>
        </>
      )
    }
    if (siteConfig.isMobile && forceAsDrawer === true) {
      return (
        <DrawerWrapper
          title={this.props.title}
          visible={visible}
          drawerProps={drawerProps}
          onChange={onChange}
          siteConfig={siteConfig}
        >
          <Flex direction='column' align='stretch' className={classes.scrollFormContainer}>
            <DrawerHeader title={this.props.title} onClickRight={() => onChange(false)} />
            <Flex.Item>
              {drawerContentNode}
            </Flex.Item>
            <div>
              {drawerFooterNode}
            </div>
          </Flex>
        </DrawerWrapper>
      )
    }
    return (
      <DrawerWrapper
        title={this.props.title}
        visible={visible}
        drawerProps={drawerProps}
        onChange={onChange}
        siteConfig={siteConfig}
      >
        {drawerContentNode}
      </DrawerWrapper>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {
    init,
    login,
    queryProtocol,
    removeCaptcha,
    loginToSaveCard,
  }
)(Form.create()(LoginDrawer))
